export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -64, duration: 1.25 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
